import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  static log(...args: unknown[]): void {
    if (!environment.production) {
      console.log(...args);
    }
  }

  static warn(...args: unknown[]): void {
    console.warn(...args);
  }

  static error(...args: unknown[]): void {
    console.error(...args);
  }
}
